import { CommentKind, DevelopmentObjective } from '../../development-objectives/models/DevelopmentObjective';
import { ICompanyObjective } from './CompanyObjective';
import { ICompanyObjectiveSettings } from './CompanyObjectiveSettings';
import { ObjectiveRights } from './ObjectiveRights';
import { IObjectiveSettings } from './ObjectiveSettings';

export interface IObjective extends Object {
  objectiveId: number;
  name: string;
  /// Value can be 0: Started, 1: Completed OR 2: Not planned
  status: number;
  dueDate?: Date;
  categoryId?: number;
  categoryName: string;
  typeName: string;
  typeId?: number;
  reviewYear: number;
  isCompanyObjective: boolean;
  description?: string;
  allowEmpLinking?: boolean;
}

export class ObjectiveStatus {
  id: number;
  name: string;
  value: number;
  icon: string;
  color: string;
  sort: number;
  isUsed: boolean;
  isHistoryStatus: boolean;
}

export interface IObjectiveListResponse {
  objectives: IObjective[];
  companyObjectives: ICompanyObjective[];
  developmentObjectives: DevelopmentObjective[];
  rights: ObjectiveRights;
  settings: IObjectiveSettings;
  companySettings: ICompanyObjectiveSettings;
  statusses: ObjectiveStatus[];
}


export class ObjectiveComment {
  objectiveCommentId: number;
  objectiveId: number;
  studentId: number;
  dateCreated: Date;
  viewableByMgr: boolean;
  viewableByStudent: boolean;
  viewableByAdmin: boolean;
  commentKind: CommentKind;
  createdById?: number;
  createdByKind: number;
  commentType: number;
  commentName: string;
  description: string;
  creatorName: string;

  // view for adding
  visible: boolean;

  constructor() {
    this.objectiveCommentId = 0;
  }
}

